import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'



export const stockRemovalOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '300',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "采购出库单编号",
            prop: "number",
            type: "input",
            width: "200",
            search: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "账号",
            prop: "account",
            search: true,
            type: 'input'
        },
        {
            label: "店铺名称",
            prop: "shopName",
            type: "input",
            search: true,
            width: "110"
        },
        // {
        //     label: "法人名称",
        //     prop: "name",
        //     width: "110",
        //     type: 'input',
        //     search: true,
        //     solt: true,
        //     formsolt: true,
        // },
        {
            label: "法人名称",
            prop: "name",
            width: "110",
            type: 'input',
            search: true,
        },
        {
            label: "店铺地址",
            prop: "address",
            type: "input",
            search: true
        },
        {
            label: "采购金额",
            prop: "price",
            type: "text"
        },
        {
            label: "采购时间",
            prop: "createTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "采购订单状态",
            prop: "status",
            // solt: true,
            search: true,
            type: 'select',
            dicData: DIC.STOCK_REMOVAL_STATUS,
            addVisdiplay: false,
            editVisdiplay: false
            //hide: true
        },
        {
            label: "支付状态",
            prop: "payStatus",
            // solt: true,
            type: 'select',
            search: true,
            dicData: DIC.STOCK_REMOVAL_PAY_STATUS,
            addVisdiplay: false,
            editVisdiplay: false
            //hide: true 
        },
        {
            label: "支付时间区间",
            prop: "payTimeInterval",
            type: "datetimerange",
            sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            // search: true,
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "支付时间",
            prop: "payTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "退回原因",
            prop: "remarks",
            type: "textarea",
            span: 24,
            max: 255
        },
        {
            label: "工程师姓名",
            prop: "workUserName",
            type: "input",
            // search: true,
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "采购时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            hide: true,
            search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        }
    ]
};